import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-auction-not-winner',
  templateUrl: './auction-not-winner.component.html',
  styleUrls: []
})
export class AuctionNotWinnerComponent implements OnInit {
  @Input() lastPrice :any;

  constructor() { }

  ngOnInit() {
  }

}
